import { render } from "./SectionTitle.vue?vue&type=template&id=63679c92"
const script = {}

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__